// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : headers
// =============================================================================
// ---Third-party imports
import React from 'react'
import clsx from 'clsx'

// ---Framework imports
import log from 'uix/logging'
import {GenericTagHandler} from 'uix/wiki/utils'
import {decodeAttribH5} from 'uix/utils'

import S from './header.scss'

export const FancyHeader = GenericTagHandler(
  'XHeader',
  ({attrib, children, text, applyTemplates}) => {
    let {ghosted, secondary, light, underlined} = decodeAttribH5(attrib)
    let cls = {
      [S.header]: true,
      [S.ghosted]: ghosted,
      [S.secondary]: secondary,
      [S.light]: light,
    }

    return (
      <div className={S.headerContainer}>
        <>
          <header className={clsx(S.header, light && S.light)}>
            {[text, applyTemplates(children)]}
          </header>
          {underlined && <div className={S.underlined}>{''}</div>}
          {ghosted && (
            <header className={clsx(S.ghosted, light && S.light)}>
              {[text, applyTemplates(children)]}
            </header>
          )}
        </>
      </div>
    )
  },
  {ghosted: [true, false], secondary: [true, false]}
)
